//Swiper
import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import Accessibility from './Accessibility';

export default class NfxSwiper {
  constructor(sliderContainer) {
    this.sliderTabs = Array.from(document.querySelectorAll('.js-swiper-tab'));
    this.sliderContainer = sliderContainer;
    this.startWithSlide = 0;

    if (this.sliderContainer && "startSlider" in this.sliderContainer.dataset) {
      this.startWithSlide = Number(this.sliderContainer.dataset.startSlider);
    }

    this.slider = null;
  }

  init() {
    this.initSlider();
    this.onSlideChange();
    if (this.sliderContainer) {
      this.addTabEventListener(this.sliderTabs);
    }

  }

  initSlider() {
    
    const sliderContainer = this.sliderContainer;
    const randomId = Math.floor(Math.random() * 1000000);
    const options = {
      modules: [Navigation, Pagination, Autoplay],
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        bulletClass: 'swiper-pagination-bullet js-slider-tab',
        //bulletElement: 'button',
        clickable: true,
         renderBullet: (index, className) => {
            return `<span class="${className}" aria-label="Slide ${index + 1 }" aria-controls="slide-${index}-${randomId}" role="tab" tabindex="0"></span>`;
        } 
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: false,
      autoplay: true,
      allowTouchMove: true,
      initialSlide: this.startWithSlide,
      on: {
        init() {
            

        
            this.slides.forEach((slide, index) => {
                slide.setAttribute('id', `slide-${index}-${randomId}`);
            })
            
            const a11ySliderNav = new Accessibility();
            const sliderTablist = sliderContainer.querySelector('.js-slider-tablist');
            const sliderTabs = sliderContainer.querySelectorAll('.js-slider-tab');
            if (sliderTablist && sliderTabs.length > 0) {
                a11ySliderNav.enableArrowNavigation(sliderTablist, sliderTabs)
                     
                sliderTabs.forEach((bullet, i) => {
                    bullet.addEventListener('keydown', (e) => {
                        if(e.key !== 'Enter') return
                        this.slides[i].querySelector('a, button')?.focus()
                        this.autoplay.stop();
                    })
                    

                        const slideLabelText = this.slides[i]?.querySelector('h1, h2, h3, h4, h5, h6, .heading-1, .heading-2, .heading-3, .heading-4, .heading-5')?.textContent ?? `Slide ${i + 1}`;
                        bullet.setAttribute('aria-label', slideLabelText);
                })
                
        }
      },
      
    }
    };

    this.slider = new Swiper(sliderContainer, options);

  }

  onSlideChange() {
    this.slider.on('slideChange', () => {
        const paginationBullets = document.querySelectorAll('.js-slider-tab');
        this.switchActiveState(paginationBullets, this.slider.activeIndex);

        this.slider.slides.forEach((slide, index) => {
            const focusableElements = slide.querySelectorAll('a, button, [tabindex="0"]')
            focusableElements.forEach(el => {
                el.setAttribute('tabindex', index === this.slider.activeIndex ? '0' : '-1');
            })
        })
    })
  }

  switchActiveState(nodeList, activeIndex) {
    nodeList.forEach((node, index) => {
      if (parseInt(node.dataset.target) === activeIndex || index === activeIndex) {
        node.classList.add('is-active');
        node.setAttribute('aria-expanded', 'true');
      } else {
        node.classList.remove('is-active');
        node.setAttribute('aria-expanded', 'false');
      }
    });
  }

  addTabEventListener(nodelist) {
    nodelist.forEach((node) => {
      node.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.target);
        this.slider.slideTo(index, 400, true);
        this.switchActiveState(this.sliderTabs, index);
      });
    });
  }
}


